import { useState, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { Button, ClickAwayListener } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ExpandLess } from "@mui/icons-material";
import PropTypes from "prop-types";

import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";

import SubNavigation from "../SubNavigation";

import { StyledLink, InternalStyledLink, StyledGrid, SubMenuCollapse } from "./styles";

const MenuItem = ({ menuItem, mainMenuLinks, onClick }) => {
  const [collapseSubMenu, setCollapseSubMenu] = useState(false);
  const [hasActiveSubLink, setHasActiveSubLink] = useState(false);
  const name = MegaMenuItemPresenter.name(menuItem);
  const subMenu = MegaMenuItemPresenter.childrenMenu(menuItem);

  const handleClickSubMenu = useCallback((value) => {
    setCollapseSubMenu(value);
  }, []);

  const handleSubLinkActiveChange = useCallback((isActive) => {
    setHasActiveSubLink(isActive);
  }, []);

  const renderSimpleLink = () => {
    return MegaMenuItemPresenter.isExternalLinkTo(menuItem) ? (
      <StyledLink
        id={MegaMenuItemPresenter.createComponentId(menuItem)}
        href={MegaMenuItemPresenter.linkTo(menuItem)}
        onClick={onClick}
      >
        {name}
      </StyledLink>
    ) : (
      <InternalStyledLink
        id={MegaMenuItemPresenter.createComponentId(menuItem)}
        exact
        to={MegaMenuItemPresenter.linkTo(menuItem)}
        component={NavLink}
        onClick={onClick}
      >
        {name}
      </InternalStyledLink>
    );
  };

  const renderCollapsableLink = () => {
    return (
      <ClickAwayListener onClickAway={() => handleClickSubMenu(false)}>
        <StyledGrid onClick={() => handleClickSubMenu(!collapseSubMenu)} hasActiveSubLink={hasActiveSubLink}>
          <Button
            id={`button-${MegaMenuItemPresenter.createComponentId(menuItem)}`}
            variant="link"
            endIcon={collapseSubMenu ? <ExpandLess /> : <ExpandMoreIcon />}
          >
            {name}
          </Button>
          <SubMenuCollapse in={collapseSubMenu}>
            <SubNavigation
              menuItem={menuItem}
              mainMenuLinks={mainMenuLinks}
              onLinkActiveChange={handleSubLinkActiveChange}
            />
          </SubMenuCollapse>
        </StyledGrid>
      </ClickAwayListener>
    );
  };

  return subMenu && subMenu.length === 0 ? renderSimpleLink() : renderCollapsableLink();
};

MenuItem.propTypes = {
  menuItem: MegaMenuItemPresenter.shape(),
  mainMenuLinks: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
};

export default MenuItem;
